import { Footer, LogoComponent } from '../components';

function LoginLayout({ children }) {
    return (

        <div className="flex flex-col h-screen">
            <div className="h-screen flex flex-col justify-center items-center flex-1">
                <LogoComponent/>
                <div className="w-full flex flex-col items-center">
                    {children}
                </div>
            </div>

            <Footer/>
        </div>
    )
}

export default LoginLayout